"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _icons = require("@material-ui/icons");

var _SingleReviewStarModule = _interopRequireDefault(require("./SingleReviewStar.module.scss"));

var _Typography = _interopRequireDefault(require("../Typography/Typography"));

var _FBUIConstants = require("../../../../utils/FBUIConstants");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * # Single Review Star
 *
 *
 * ## PropTypes:
 * ```js
 *  SingleReviewStar.propTypes = {
 *    reviewAvg: PropTypes.number,
 *    numberOfReviews: PropTypes.number,
 *    className: PropTypes.string
 *  };
 * ```
 */
var SingleReviewStar = function SingleReviewStar(_ref) {
  var reviewAvg = _ref.reviewAvg,
      numberOfReviews = _ref.numberOfReviews,
      className = _ref.className;
  return /*#__PURE__*/_react.default.createElement("div", {
    className: [_SingleReviewStarModule.default.SingleReviewStarContainer, className].join(' ')
  }, /*#__PURE__*/_react.default.createElement(_icons.Star, {
    className: [_SingleReviewStarModule.default.StarIcon, numberOfReviews > 0 ? _SingleReviewStarModule.default.yellow : _SingleReviewStarModule.default.grey].join(' ')
  }), /*#__PURE__*/_react.default.createElement(_Typography.default, {
    type: _FBUIConstants.TYPOGRAPHY_TYPES.BODY_L_BOLD
  }, reviewAvg > 0 ? reviewAvg : undefined), /*#__PURE__*/_react.default.createElement(_Typography.default, {
    type: _FBUIConstants.TYPOGRAPHY_TYPES.BODY_L,
    className: _SingleReviewStarModule.default.RatingCount
  }, "(", reviewAvg > 0 ? numberOfReviews : 'No', " reviews)"));
};

SingleReviewStar.propTypes = {
  reviewAvg: _propTypes.default.oneOfType([_propTypes.default.number, _propTypes.default.string]),
  numberOfReviews: _propTypes.default.oneOfType([_propTypes.default.number, _propTypes.default.string]),
  className: _propTypes.default.string
};
var _default = SingleReviewStar;
exports.default = _default;

//# sourceMappingURL=SingleReviewStar.js.map